type RadioGroupFieldProps = {
  label: string;
  name: string;
  options: string[];
  value: string;
  onChange: (name: string, value: string) => void;
};

export const RadioGroupField = ({
  label,
  name,
  options,
  value,
  onChange,
}: RadioGroupFieldProps) => {
  return (
    <div>
      <label className="block text-[16px] md:text-[17px] font-medium text-[#111827] mb-2">
        {label} <span className="text-red-500">*</span>
      </label>
      <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
        {options.map((option) => (
          <label key={option} className="flex items-start gap-2 cursor-pointer">
            <input
              type="radio"
              name={name}
              value={option}
              checked={value === option}
              onChange={(e) => onChange(name, e.target.value)}
              className="mt-[2px] w-4 h-4 text-[#026857] border-gray-300 focus:ring-[#026857]"
            />
            <span className="text-[16px] leading-5 text-[#111827]">{option}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

